export default "__VITE_ASSET__Co7XLAJ5__"